<template>
    <div class="saved-orders">
        <div v-if="offersData" class="page">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Oferte salvate</h1>
                    <p v-if="offersData.total > 0">Se afișează rezultatele {{offersData.from}}-{{offersData.to}} din {{offersData.total}}.</p>
                    <p v-else>Se afișează 0 rezultate.</p>

                    <div class="white-page" v-if="offersData.total === 0">
                        <h1>Nicio ofertă</h1>
                        <p>
                            Nicio ofertă nu a fost salvată până acum.
                        </p>
                    </div>

                    <div v-else>
                        <div class="white-page">
                            <table class="table table-sm table-borderless table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Client</th>
                                        <th scope="col">Dată ofertă</th>
                                        <th scope="col">Număr produse</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="offer in offersData.data" :key="offer.id">
                                        <td>{{offer.id}}</td>
                                        <template>
                                            <td v-if="offer.extra_data && offer.extra_data.clientName">{{offer.extra_data.clientName}}</td>
                                            <td v-else><i>Necunoscut</i></td>
                                        </template>
                                        <td>{{formatDate(offer.created_at)}}</td>
                                        <td>{{offer.product_count}}</td>
                                        <td class="nowrap">
                                            <router-link :to="`/offer/${offer.id}/view`" v-slot="{ href, navigate }">
                                                <a :href="href" @click="navigate">
                                                    <b-button variant="primary" size="sm">
                                                        <b-icon icon="eye" />
                                                        Vezi oferta
                                                    </b-button>
                                                </a>
                                            </router-link>
                                            <router-link :to="`/offer/${offer.id}/edit`" v-slot="{ href, navigate }">
                                                <a :href="href" @click="navigate">
                                                    <b-button variant="secondary" size="sm" class="ml-2">
                                                        <b-icon icon="pencil-square" />
                                                        Editează
                                                    </b-button>
                                                </a>
                                            </router-link>
                                            <b-button variant="danger" size="sm" class="ml-2" @click="() => deleteOffer(offer.id)">
                                                <b-icon icon="trash" />
                                                Șterge
                                            </b-button>
                                            <b-button variant="outline-danger" size="sm" class="ml-2" @click="() => downloadPdfFile(offer.id)">
                                                <b-icon icon="file-text" />
                                                PDF
                                            </b-button>
                                            <b-button variant="outline-success" size="sm" class="ml-2" @click="() => downloadXlsxFile(offer.id)">
                                                <b-icon icon="file-spreadsheet" />
                                                XLSX
                                            </b-button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <b-pagination
                                v-model="page"
                                :total-rows="offersData.total"
                                :per-page="offersData.per_page"
                                @change="changePage"
                                align="right"
                                first-number
                                last-number
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "@/utils/axios-instance";
    import moment from "moment";

    export default {
        name: 'AllOffers',
        components: {},
        data() {
            return {
                errorMessage: null,
                page: 1,

                offersData: null,
            }
        },
        computed: {
            groupID() {
                return this.$route.params.id
            }
        },
        created: async function () {
            let loader = this.$loading.show();
            await this.loadOffers();
            loader.hide();
        },
        watch: {
            // call again the method if the route changes
            '$route': 'fetchData'
        },
        methods: {
            async loadOffers() {
                let {data} = await axios.get(`offer/get-all?page=${this.page}`);

                if(this.page > data.last_page) {
                    this.page = data.last_page;
                    await this.loadOffers();

                    return;
                }

                this.offersData = data;
            },
            async changePage(page) {
                let loader = this.$loading.show();

                this.page = page;
                await this.loadOffers();

                loader.hide();
            },
            async downloadPdfFile(offerId) {
                let loader = this.$loading.show();

                let response = await axios({
                    url: `offer/${offerId}/view/pdf`,
                    method: 'GET',
                    responseType: 'blob',
                });


                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Oferta.pdf');
                document.body.appendChild(fileLink);

                fileLink.click();

                loader.hide();
            },
            async downloadXlsxFile(offerId) {
                let loader = this.$loading.show();

                try {
                    let response = await axios({
                        url: `offer/${offerId}/view/xlsx`,
                        method: 'GET',
                        responseType: 'blob',
                    });


                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Oferta.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
            async deleteOffer(offerId) {
                let loader = this.$loading.show();

                try {
                    await axios.delete(`offer/${offerId}`);
                    await this.loadOffers();
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
            formatDate(date) {
                return moment(date).format('DD.MM.YYYY')
            }
        }
    }
</script>

<style scoped>
    .saved-orders {
        flex-grow: 1;
        display: flex;
    }

    .page {
        flex-grow: 1;
        position: relative;
    }

    .cover {
        width: 100%;
        height: 264px;
        position: relative;
        background: #024A8C;
    }

    .container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 60px;
        color: white;
        width: 100%;
    }

    .white-page {
        background: white;
        border-radius: 5px;
        color: black;
        padding: 25px 20px;

        margin-top: 50px;
        margin-bottom: 20px;

        -webkit-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        -moz-box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
        box-shadow: 0px 0px 14px 2px rgba(0, 0, 0, 0.31);
    }

    .white-page h1 {
        color: #024A8C;
        font-weight: 600;
    }

    .white-page h2, h3, h4, h5, h6 {
        color: #6F6F6F;
        margin-top: 10px;
    }

    h1 {
        font-size: 2rem;
    }

    h2 {
        font-size: 1.1rem;
    }

    h3 {
        font-size: 1rem;
    }

    th {
        color: #024A8C;
        font-weight: 600;
    }

    table td {
        white-space: normal;
        vertical-align: middle;
    }

    table td.nowrap {
        width: 1%;
        white-space: nowrap;
    }

    .product-codes {
        color: #6F6F6F;
        font-size: 0.7rem;
        word-wrap: break-word;
    }
    .product-codes span::after {
        content: '; ';
    }

    .total-profit {
        color: #024A8C;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .total-profit .profit {
        font-weight: 800;
        font-size: 1.3rem;
    }

    .currencies div {
        margin-bottom: 5px;
    }
</style>
